import { highlightLinksInText } from "../../helpers/application";
import useTranslation from "next-translate/useTranslation";

const AboutContent = ({ group }) => {
  const { t } = useTranslation("common");

  return (
    <>
      {" "}
      <div className="mt-2">
        <small className="text-uppercase text-gray1 label-2 d-flex align-items-center mb-1">
          {t("groups.new.description.label")}
        </small>
        <span className="font-size-md">
          <div className="pre-line" dangerouslySetInnerHTML={{ __html: highlightLinksInText(group.description) }} />
        </span>
      </div>
      <div className="mt-2 text-center">
        {group.video_url && (
          <iframe className="ms-auto me-auto" width="100%" height="200" src={group.video_url} allowFullScreen></iframe>
        )}

        {group.image?.url && !group.video_url && (
          <img
            src={group.image.url.replace(process.env.NEXT_PUBLIC_API_URL, process.env.NEXT_PUBLIC_API_LOCAL_URL)}
            style={{ maxWidth: "100%" }}
          />
        )}
      </div>
    </>
  );
};

export default AboutContent;
